import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/contexts/ThemeProvider";

function labelStyles(theme) {
  switch (theme) {
    case "theme-castlewood":
      return "smallcaps-wide font-display text-[12px] text-[hsl(var(--brand-accent))]";
    case "theme-brionj":
      return "smallcaps-xwide font-ui text-[11px] text-[hsl(var(--brand-accent))]";
    case "theme-vela":
      return "smallcaps font-ui text-[12px] text-foreground";
    case "theme-admin":
      return "smallcaps font-ui text-[11px] text-muted-foreground";
    default:
      return "smallcaps font-ui text-[12px] text-muted-foreground";
  }
}

const BrandLabel = ({ children, className, withRule = false, ...rest }) => {
  const { theme } = useTheme();
  return (
    <span className={cn("inline-flex items-center gap-3 font-medium", labelStyles(theme), className)} {...rest}>
      {withRule && <span className="inline-block w-8 h-px bg-[hsl(var(--brand-accent))]" aria-hidden="true" />}
      <span>{children}</span>
      {withRule && <span className="inline-block w-8 h-px bg-[hsl(var(--brand-accent))]" aria-hidden="true" />}
    </span>
  );
};
export default BrandLabel;
export { BrandLabel };
